export type Waiver = {
  guid: string;
  title: string;
  version: number;
  text: string;
  service_selection_type: ServiceSelectionType;
};

export enum QuestionValidationTypes {
  required = 'required',
}

export type Question = {
  guid: string;
  text: string;
  type: string; // TODO: Change to Enum
  version: number;
  validations: [{ type: QuestionValidationTypes }] | [];
};

export enum FormStatus {
  not_required = 'not_required',
  submitted = 'submitted',
  incomplete = 'incomplete',
}

export type Form = {
  status: FormStatus;
  waivers?: Waiver[];
  questions?: Question[];
};

export enum ServiceSelectionType {
  all = 'all',
  selected_services = 'selected_services',
}
